<template>
    <div class="my-5 row justify-content-center">
        <div class="project-box p-3"
            :class="isdarktheme ? ['shadow_dark', 'bg_dark'] : ['shadow_light', 'bg-white']">
            <h1>Selecione o projeto</h1>
            <div class="row justify-content-center">
                <button
                    v-for="(project, key) of projects"
                    :key="key"
                    class="btn col-8 my-3"
                    :class="isdarktheme ? ['btn-dark', 'border-dark'] : 'btn-light'"
                    style="border: 1px solid #ced4da"
                    @click="
                        () => {
                            projectSelected = project;
                        }
                    "
                >
                    {{ project.name }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['projects_parent', 'isdarktheme'],
    data() {
        return {
            projects: this.projects_parent,
            projectSelected: null,
        }
    },
    methods: {
        updateProject() {
            this.$emit('updateProject', this.projectSelected)
        }
    },
    watch: {
        projectSelected() {
            this.updateProject();
        }
    }
}
</script>
<style>
.project-box {
    width: 35rem !important;
    border-radius: 2.5%;
}
.shadow_dark {
    box-shadow: 3px 3px 10px rgb(20, 30, 35) !important;
}
.shadow_light {
    box-shadow: 3px 3px 10px#DFD2CE;
}
.bg_dark > .modal-header, .bg_dark > .modal-footer {
    border-color: #2c3e50 !important;
}
</style>